import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HashRouter } from "react-router-dom";
import Main from "./main";
import AnimCursor from "./AnimatedCursor";
import Navbar from "./Navbar";
import Projects from "./Projects";
import Contact from "./Contact";
import About from "./About";
import Error from "./Error";
import { ThemeProvider } from "./themeContext";
import LanguageContext from "./LanguageContext";

function App() {
  return (
    <main className='no-scroll main-comp flex justify-center  bg-[#242424] dark:bg-[#E3E3E3]   min-h-[100vh]'>
      <section className='max-w-[1700px] grow'>
        <ThemeProvider>
          <LanguageContext>
            <HashRouter>
              <AnimCursor />
              <Navbar />

              <Routes>
                <Route path='/' exact element={<Main />} />
                <Route path='/projects' element={<Projects />} />
                <Route path='/contact' element={<Contact />} />
                <Route path='/about' element={<About />} />
                <Route path='/*' element={<Error />} />
              </Routes>
            </HashRouter>
          </LanguageContext>
        </ThemeProvider>
      </section>
    </main>
  );
}

// react world

export default App;
